var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "689.000000pt",
    height: "362.000000pt",
    viewBox: "0 0 689.000000 362.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,362.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3927 3025 c-74 -51 -87 -116 -87 -457 l0 -248 -807 -1 c-445 0 -844 -4 -889 -8 -161 -15 -313 -123 -387 -273 -44 -89 -56 -141 -57 -235 0 -192 116 -372 298 -460 104 -50 147 -52 1064 -52 l776 -1 4 -287 3 -288 27 -50 c15 -27 39 -59 54 -69 39 -28 122 -33 170 -10 43 20 746 711 940 923 140 153 158 192 152 321 -6 111 -19 136 -156 285 -175 192 -863 870 -917 904 -64 41 -133 43 -188 6z m538 -585 c379 -379 501 -508 532 -564 16 -27 16 -105 0 -133 -28 -51 -184 -215 -564 -594 l-403 -402 0 219 c0 121 -3 282 -7 360 l-6 141 -945 8 -945 7 -53 25 c-63 30 -137 105 -167 171 -16 36 -22 66 -22 128 0 72 4 87 34 148 36 70 86 121 150 153 32 15 79 18 391 24 195 4 626 7 958 8 l602 1 0 294 c0 311 6 416 24 416 6 0 195 -185 421 -410z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.a07108ff67e0ef36220f42d462723235.svg";
export { ForwardRef as ReactComponent };